export default class LazyLoad {
    constructor() {
        this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
            rootMargin: '200px 0px',
        });
        this.observeNew(document.documentElement);
        document.addEventListener('lazyload:observe', (e) => {
            this.observeNew(e.detail);
        });
    }
    observeNew(root) {
        root.querySelectorAll('img[data-lazy], [data-lazy-bg]').forEach((el) => {
            // Swiper translates off-screen slides via CSS transform, so their
            // bounding rect is outside the viewport — the observer never fires.
            // Observe the swiper container instead and load all images inside
            // it when the container enters the viewport.
            const swiper = el.closest('.swiper');
            this.observer.observe(swiper !== null && swiper !== void 0 ? swiper : el);
        });
    }
    onIntersect(entries) {
        entries.forEach((entry) => {
            if (!entry.isIntersecting)
                return;
            const target = entry.target;
            if (target.classList.contains('swiper')) {
                target.querySelectorAll('img[data-lazy], [data-lazy-bg]').forEach((el) => {
                    this.load(el);
                });
            }
            else {
                this.load(target);
            }
            this.observer.unobserve(target);
        });
    }
    load(el) {
        if (el instanceof HTMLImageElement && el.dataset.lazy) {
            if (el.dataset.srcset) {
                el.srcset = el.dataset.srcset;
                delete el.dataset.srcset;
            }
            if (el.dataset.sizes) {
                el.sizes = el.dataset.sizes;
                delete el.dataset.sizes;
            }
            el.src = el.dataset.lazy;
            delete el.dataset.lazy;
        }
        else if (el.dataset.lazyBg) {
            el.style.backgroundImage = `url('${el.dataset.lazyBg}')`;
            delete el.dataset.lazyBg;
        }
    }
}
